const Errorpage = () => {
  return (
    <div className="bg-[#FFFAF0]">
      <lottie-player
        src="https://assets1.lottiefiles.com/packages/lf20_yCCORfUI6a.json"
        speed="0.4"
        width="300px"
        height="300px"
        loop
        autoplay></lottie-player>
    </div>
  );
};

export default Errorpage;
